import React from 'react'

import SEO from "../components/seo"
import {seo} from '../components/data/seo'

import Layout from "../components/organisms/Layout"
import TopContainer from '../components/molecules/TopContainer'
import AboutMainTop from '../components/molecules/AboutMainTop'
import AboutCareerEducation from '../components/molecules/AboutCareerEducation'
import AboutLanguages from '../components/molecules/AboutLanguages'
import AboutHobby from '../components/molecules/AboutHobby'

export default ({location}) => {
  return (
    <Layout location={location}>
      <SEO title={seo.about.title} description={seo.about.description} lang="en"/>
      <div>
        <TopContainer title="About"/>
        <AboutMainTop/>
        <AboutCareerEducation type="career"/>
        <AboutCareerEducation type="education"/>
        <AboutLanguages/>
        <AboutHobby/>
      </div>
    </Layout>
  )
}

